import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getJToken, getUserEmail, getTenantId, getUserId } from "../services/authService";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function callSSE({
    endpoint, 
    body, 
    signal,
    onOpen, 
    onMessage, 
    onError, 
    onClose
}) {
    const token = getJToken();
    const userEmail = getUserEmail();
    const userId = getUserId();
    const tenantId = getTenantId();

    // Debug logging
    console.log('Token:', token ? 'Present' : 'Missing');
    console.log('User Email:', userEmail);
    console.log('User ID:', userId);
    console.log('Tenant ID:', tenantId);

    const headers = {
        'Content-Type': 'application/json',
        'x-user-email': String(userEmail || ''),
        'x-user-id': String(userId || ''),
        'x-tenant-id': String(tenantId || ''),
        'x-request-id': Math.floor(Math.random() * 1000).toString()
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (process.env.REACT_APP_SUBSCRIPTION_KEY != null && process.env.REACT_APP_SUBSCRIPTION_KEY != undefined && process.env.REACT_APP_SUBSCRIPTION_KEY != '') {
        headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_SUBSCRIPTION_KEY;
    }

    console.log('Headers object:', headers);

    const controller = await fetchEventSource(`${BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
        signal,
        openWhenHidden: true,
        onopen: async (res) => {
            console.log('Response status:', res.status);
            
            if (res.status === 422) {
                const errorText = await res.text();
                console.error('422 Validation Error:', errorText);
                throw new Error(`Validation failed: ${errorText}`);
            }
            if (res.status === 401) {
                const errorText = await res.text();
                console.error('401 Unauthorized:', errorText);
                throw new Error('Unauthorized');
            }
            if (!res.ok) {
                const errorText = await res.text();
                console.error(`HTTP ${res.status}:`, errorText);
                throw new Error(`HTTP ${res.status}`);
            }
            onOpen?.();
        },
        onmessage: (ev) => {
            try {
                onMessage(JSON.parse(ev.data), ev);
            } catch {
                onMessage(ev.data, ev);
            }
        },
        onerror: (err) => {
            console.error('SSE Error:', err);
            onError?.(err);
            throw err;
        },
        onclose: () => {
            console.log('SSE connection closed');
            onClose?.();
        }
    });

    return controller;
}